module.exports = __webpack_public_path__ + "static/media/Claim-icon-1.a6f7ea1b.svg";